import { ITrialForm } from '@/types/trial.d';
import { IPAGE } from '@/types/base.d';
import fetch from './index';

// 获取试听课list
const getTrialList = (params: IPAGE) => fetch.axios_admin.get('/auditionCourse/page', { params });

// 添加试听课
const addTrial = (params: ITrialForm) => fetch.axios_admin.post('/auditionCourse', params);

// 编辑试听课
const editTrial = (params: ITrialForm) => fetch.axios_admin.put('/auditionCourse', params);

// 删除试听课
const removeTrial = (params: {id: string}) => fetch.axios_admin.remove(`/auditionCourse/id/${params.id}`);

export default {
  getTrialList,
  addTrial,
  editTrial,
  removeTrial,
};
